<template>
  <div
    v-if="user.notifications.length"
    class="notification notification-system mb-3  px-lg-5 px-3 py-3 animate__animated animate__fadeIn d-md-flex justify-content-between"
  >
    <div class="d-flex align-items-md-center">

      <i class="far fa-lg fa-info-circle mr-3 color-1"></i> <span class="font-weight-bold color-1 mr-3">{{user.notifications[0].message}}</span> <span>{{user.notifications[0].description}}</span>
    </div>
    <div class="mt-3 mt-md-0 d-flex align-items-center">
      <a
        v-if="user.notifications[0].doc_url"
        v-on:click="dismissNotification()"
        :href="user.notifications[0].doc_url"
        target="_bank"
        class="mr-3"
      >Learn more</a> <button
        class="btn btn-primary btn-sm"
        v-on:click="dismissNotification()"
      >dismiss</button>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
export default {
  methods: {
    dismissNotification: function () {
      axios
        .post("/api/notifications", {
          notification_id: this.user.notifications[0].id,
          _method: "DELETE",
        })
        .then(
          (response) => {
            this.getUser().then((result) => {});
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
  },
};
</script>
